/* BOTÁNICA® — tienda Shopify.
   Portado de app.js del sitio estático, con una diferencia de fondo:
   el carrito es el CARRITO REAL DE SHOPIFY (/cart/add.js, /cart/change.js, /cart.js)
   y el pago sale por /checkout. No hay carrito en localStorage ni checkout por WhatsApp.
   Los descuentos (2.º frasco a mitad de precio, envío gratis del Kit) los resuelve Shopify:
   acá solo se muestran los totales que devuelve el carrito. */
(function () {
  const D = window.BOTANICA_DATOS || {};
  const R = D.rutas || {};
  const T = D.textos || {};
  const ENVIO = D.envioGratis || 0; // en centavos
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));

  /* ---------- plata ---------- */
  function money(centavos) {
    const formato = D.moneyFormat || '${{amount_with_comma_separator}}';
    const hueco = /\{\{\s*(\w+)\s*\}\}/;
    const m = formato.match(hueco);
    if (!m) return formato;
    const armar = (n, dec, miles, coma) => {
      if (isNaN(n) || n === null) return '0';
      const fijo = (n / 100).toFixed(dec);
      const partes = fijo.split('.');
      const enteros = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
      return enteros + (partes[1] ? coma + partes[1] : '');
    };
    let valor;
    switch (m[1]) {
      case 'amount': valor = armar(centavos, 2, ',', '.'); break;
      case 'amount_no_decimals': valor = armar(centavos, 0, ',', '.'); break;
      case 'amount_with_comma_separator': valor = armar(centavos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valor = armar(centavos, 0, '.', ','); break;
      case 'amount_with_space_separator': valor = armar(centavos, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': valor = armar(centavos, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': valor = armar(centavos, 2, "'", '.'); break;
      default: valor = armar(centavos, 2, '.', ',');
    }
    return formato.replace(hueco, valor);
  }
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const foto = (url, ancho) => url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + ancho + 'x$1$2') : '';

  /* ---------- API del carrito ---------- */
  let carrito = null;
  let trabajando = false;

  async function pedir(url, datos) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || T.errorCarrito || 'No se pudo actualizar el carrito.');
    return j;
  }

  async function traer() {
    const r = await fetch((R.carrito || '/cart') + '.js', { headers: { Accept: 'application/json' } });
    carrito = await r.json();
    pintar(carrito);
    return carrito;
  }

  function ocupado(si) {
    trabajando = si;
    const d = $('#drawer');
    if (d) d.classList.toggle('cargando', si);
  }

  async function agregar(items, opciones) {
    const o = opciones || {};
    if (trabajando) return;
    ocupado(true);
    try {
      await pedir((R.agregar || '/cart/add') + '.js', { items: items });
      await traer();
      if (!o.silencioso) { abrir(); aviso(o.mensaje || T.agregado || 'Agregado al carrito'); }
    } catch (e) {
      aviso(e.message);
    } finally {
      ocupado(false);
    }
  }

  async function cambiar(clave, cantidad) {
    if (trabajando) return;
    ocupado(true);
    try {
      await pedir((R.cambiar || '/cart/change') + '.js', { id: clave, quantity: cantidad });
      await traer();
    } catch (e) {
      aviso(e.message);
    } finally {
      ocupado(false);
    }
  }

  /* ---------- dibujar el carrito ---------- */
  function enCarrito(idVariante) {
    if (!carrito) return null;
    return carrito.items.find(l => l.variant_id === idVariante) || null;
  }

  function frascosEnCarrito() {
    if (!carrito || !D.frascos) return 0;
    const ids = D.frascos.map(f => f.id);
    return carrito.items.reduce((a, l) => a + (ids.indexOf(l.variant_id) >= 0 ? l.quantity : 0), 0);
  }

  function pintar(c) {
    $$('.btn-carrito b').forEach(b => { b.textContent = c.item_count; });
    $$('[data-carrito-total]').forEach(e => { e.innerHTML = money(c.total_price); });
    const cont = $('#items');
    if (!cont) return;
    const resumen = $('#resumen');

    if (!c.items.length) {
      cont.innerHTML = '<div class="vacio"><p>' + esc(T.vacio || 'Tu carrito está vacío.') + '</p><p>' +
        esc(T.vacioTexto || '') + '</p><a class="btn btn-verde mt" href="' + (R.catalogo || '/collections/all') + '" data-cerrar>' +
        esc(T.verProductos || 'Ver productos') + '</a></div>';
      if (resumen) resumen.hidden = true;
      return;
    }

    /* Un pedido de solo productos digitales (el ebook) no se despacha: no pide
       dirección ni paga envío. En ese caso no va la barra de envío gratis ni la
       fila de envío del resumen, porque no hay nada que cotizar ni que ganar.
       Si la línea no informa requires_shipping, se toma como que se despacha. */
    const pideEnvio = c.items.some(l => l.requires_shipping !== false);
    const pct = ENVIO ? Math.min(100, Math.round(c.total_price / ENVIO * 100)) : 100;
    const gratis = (pideEnvio && ENVIO) ? c.total_price >= ENVIO : false;
    const envio = (!pideEnvio || !ENVIO) ? '' : gratis
      ? '<div class="envio-barra ok"><b>' + esc(T.tieneEnvio || 'Tenés envío gratis') + '</b><i style="width:100%"></i></div>'
      : '<div class="envio-barra"><b>' + esc((T.faltaEnvio || 'Te faltan {monto} para el envío gratis').replace('{monto}', money(ENVIO - c.total_price))) + '</b><i style="width:' + pct + '%"></i></div>';

    const activas = [];
    (c.cart_level_discount_applications || []).forEach(a => { if (activas.indexOf(a.title) < 0) activas.push(a.title); });
    c.items.forEach(l => (l.line_level_discount_allocations || []).forEach(a => {
      const t = a.discount_application && a.discount_application.title;
      if (t && activas.indexOf(t) < 0) activas.push(t);
    }));
    if (gratis) activas.push(T.envioGratisChip || 'Envío gratis');

    const chips = activas.length ? '<div class="ofertas-mini">' + activas.map(a => '<span>✓ ' + esc(a) + '</span>').join('') + '</div>' : '';

    const lineas = c.items.map(l => {
      const unidad = Math.round(l.final_line_price / l.quantity);
      const bajo = unidad !== l.original_price;
      const etiquetas = (l.line_level_discount_allocations || []).map(a => a.discount_application.title);
      const chip = etiquetas.length ? etiquetas[0] : (l.requires_shipping === false ? (T.digital || 'Digital') : '');
      const ahorro = l.original_line_price - l.final_line_price;
      const variante = l.product_has_only_default_variant ? '' : '<span class="unit">' + esc(l.variant_title || '') + '</span>';
      return '<div class="item" data-clave="' + esc(l.key) + '">' +
        '<img src="' + esc(foto(l.featured_image && l.featured_image.url, 160)) + '" alt="">' +
        '<div class="dat"><b>' + esc(l.product_title) + '</b>' +
        (chip ? '<span class="etq">' + esc(chip) + '</span>' : '') + variante +
        '<span class="unit">' + (bajo ? '<s>' + money(l.original_price) + '</s> ' : '') + money(unidad) + ' <small>c/u</small></span>' +
        '<div class="c"><button type="button" data-menos="' + esc(l.key) + '" aria-label="Quitar uno">−</button><span>' + l.quantity + '</span>' +
        '<button type="button" data-mas="' + esc(l.key) + '" aria-label="Sumar uno">+</button></div></div>' +
        '<div class="tot">' + (ahorro > 0 ? '<s>' + money(l.original_line_price) + '</s>' : '') +
        '<b>' + money(l.final_line_price) + '</b>' +
        (ahorro > 0 ? '<em>' + esc(T.ahorras || 'Ahorrás') + ' ' + money(ahorro) + '</em>' : '') +
        '<button class="quitar" type="button" data-quitar="' + esc(l.key) + '">' + esc(T.quitar || 'Quitar') + '</button></div></div>';
    }).join('');

    cont.innerHTML = envio + chips + lineas + sumarHTML(c);

    if (resumen) {
      resumen.hidden = false;
      const lista = c.items.reduce((a, l) => a + l.original_line_price, 0);
      const ahorro = lista - c.total_price;
      const fs = $('#sub'); if (fs) fs.innerHTML = money(lista);
      const fa = $('#ahorro');
      if (fa) {
        fa.innerHTML = ahorro > 0 ? '−' + money(ahorro) : '—';
        fa.parentElement.classList.toggle('hay', ahorro > 0);
      }
      const fd = $('#desc');
      if (fd) {
        const nombres = (c.cart_level_discount_applications || []).map(a => a.title).join(', ');
        fd.innerHTML = c.total_discount > 0 ? '−' + money(c.total_discount) + (nombres ? ' (' + esc(nombres) + ')' : '') : '—';
      }
      const fe = $('#envio');
      if (fe) {
        /* La fila lleva display:flex por clase, así que el atributo hidden no
           alcanza para esconderla: se apaga con estilo en línea. */
        if (fe.parentElement) fe.parentElement.style.display = pideEnvio ? '' : 'none';
        fe.textContent = gratis ? (T.envioGratisFila || 'Gratis') : (T.envioCotiza || 'Se cotiza al pagar');
      }
      const ft = $('#tot'); if (ft) ft.innerHTML = money(c.total_price);
    }
  }

  /* Interruptores «Sumá con un toque»: lo que falta para completar el par o el sistema.
     Muestra el precio de lista; el descuento lo aplica Shopify al pagar. */
  function sumarHTML(c) {
    const kit = D.kit;
    if (kit && enCarrito(kit.id)) return '';
    const filas = [];
    const n = frascosEnCarrito();
    if (D.ebook && D.ebook.id && !enCarrito(D.ebook.id) && n >= 1) {
      filas.push({ p: D.ebook, nota: T.sumarEbook || 'Sumalo a tu pedido' });
    }
    (D.frascos || []).forEach(f => {
      if (filas.length >= 3 || enCarrito(f.id) || !f.disponible) return;
      filas.push({ p: f, nota: n % 2 === 1 ? (T.sumarCompleta || 'Completa el par') : (T.sumarSiguiente || 'Y el siguiente va en el par') });
    });
    if (!filas.length && !(kit && n >= 2 && n < 4)) return '';
    const cajaKit = (kit && kit.id && n >= 2 && n < 4)
      ? '<div class="sumar kit"><img src="' + esc(foto(kit.imagen, 120)) + '" alt=""><div><b>' + esc(kit.titulo) + '</b><small>' + esc(T.kitNota || 'Los 4 frascos, el ebook y envío gratis') + '</small></div><button class="btn-mini" type="button" data-agregar-var="' + kit.id + '">' + esc(T.sumar || 'Sumar') + '</button></div>'
      : '';
    return '<div class="sumar-titulo">' + esc(T.sumarTitulo || 'Sumá con un toque') + '</div>' +
      filas.map(f => '<label class="sumar"><img src="' + esc(foto(f.p.imagen, 120)) + '" alt="">' +
        '<div><b>' + esc(f.p.corto || f.p.titulo) + '</b><small>' + esc(f.nota) + '</small></div>' +
        '<span class="precio-s">' + money(f.p.precio) + '</span>' +
        '<input type="checkbox" class="switch" data-toggle-var="' + f.p.id + '"><i></i></label>').join('') + cajaKit;
  }

  /* ---------- abrir / cerrar ---------- */
  function abrir() {
    const d = $('#drawer'), v = $('#velo');
    if (!d) return;
    d.classList.add('abierto'); if (v) v.classList.add('abierto');
    document.body.style.overflow = 'hidden';
    const c = d.querySelector('[data-cerrar]'); if (c) c.focus();
  }
  function cerrar() {
    const d = $('#drawer'), v = $('#velo');
    if (d) d.classList.remove('abierto');
    if (v) v.classList.remove('abierto');
    document.body.style.overflow = '';
  }

  /* ---------- cupón: Shopify lo aplica por /discount/CODIGO ---------- */
  function aplicarCupon() {
    const i = $('#cupon-in');
    if (!i) return;
    const v = (i.value || '').trim().toUpperCase();
    if (!v) { aviso(T.cuponVacio || 'Escribí el código del cupón.'); return; }
    const raiz = (R.inicio && R.inicio !== '/') ? R.inicio.replace(/\/$/, '') : '';
    window.location.href = raiz + '/discount/' + encodeURIComponent(v) + '?redirect=' + encodeURIComponent(R.carrito || '/cart');
  }

  /* ---------- packs: arman el pedido con las variantes reales ---------- */
  function packs(raiz) {
    $$('.packs[data-packs]', raiz).forEach(caja => {
      if (caja.dataset.listo === '1') return;
      caja.dataset.listo = '1';
      const opciones = $$('.pack', caja);
      const boton = $('[data-pack-agregar]', caja);
      const refrescar = () => {
        const sel = $('.pack.sel', caja) || opciones[0];
        if (!sel) return;
        let total = parseInt(sel.dataset.total, 10) || 0;
        $$('.sub input[data-sub]', caja).forEach(ch => {
          const fila = ch.closest('.sub');
          if (ch.checked && fila && fila.closest('.pack') === sel) total += parseInt(ch.dataset.monto, 10) || 0;
        });
        const et = $('[data-pack-total]', caja);
        if (et) et.innerHTML = money(total);
      };
      caja.addEventListener('change', e => {
        if (e.target.matches('input[type=radio]')) {
          opciones.forEach(o => o.classList.toggle('sel', o.contains(e.target)));
        }
        refrescar();
      });
      if (boton) boton.addEventListener('click', () => {
        const sel = $('.pack.sel', caja) || opciones[0];
        if (!sel) return;
        let items = [];
        try { items = JSON.parse(sel.dataset.items || '[]'); } catch (e) { items = []; }
        $$('.sub input[data-sub]', caja).forEach(ch => {
          if (!ch.checked) return;
          const fila = ch.closest('.pack');
          if (fila && fila !== sel) return;
          try { items = items.concat(JSON.parse(ch.dataset.items || '[]')); } catch (e) { /* nada */ }
        });
        if (items.length) agregar(items, { mensaje: T.packAgregado || 'Pack agregado al carrito' });
      });
      refrescar();
    });
  }

  /* ---------- galería de producto: carrusel deslizable con miniaturas ---------- */
  function galeriaProducto(raiz) {
    $$('.galeria-prod[data-fotos]', raiz).forEach(g => {
      let fotos = [];
      try { fotos = JSON.parse(g.dataset.fotos); } catch (e) { return; }
      if (!fotos.length) return;
      let i = 0;
      g.innerHTML = '<div class="gp-marco"><div class="gp-pista">' + fotos.map((f, k) =>
        '<figure class="gp-slide"><img src="' + esc(f.src) + '" alt="' + esc(f.alt || '') + '"' + (k ? ' loading="lazy"' : '') + '>' +
        (f.pie ? '<figcaption' + (f.arriba ? ' class="arriba"' : '') + '>' + esc(f.pie) + '</figcaption>' : '') + '</figure>').join('') + '</div>' +
        '<button class="gp-ctrl prev" type="button" aria-label="Foto anterior">‹</button><button class="gp-ctrl next" type="button" aria-label="Foto siguiente">›</button>' +
        '<div class="gp-puntos">' + fotos.map((_, k) => '<button type="button" aria-label="Foto ' + (k + 1) + '"></button>').join('') + '</div></div>' +
        '<div class="gp-minis">' + fotos.map((f, k) => '<button type="button" aria-label="Ver foto ' + (k + 1) + '"><img src="' + esc(f.src) + '" alt="" loading="lazy"></button>').join('') + '</div>';
      const pista = $('.gp-pista', g), puntos = $$('.gp-puntos button', g), minis = $$('.gp-minis button', g);
      const ir = n => {
        i = (n + fotos.length) % fotos.length;
        pista.style.transform = 'translateX(-' + i * 100 + '%)';
        puntos.forEach((b, k) => b.classList.toggle('activo', k === i));
        minis.forEach((b, k) => b.classList.toggle('activo', k === i));
        if (minis[i]) minis[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
      $('.prev', g).addEventListener('click', () => ir(i - 1));
      $('.next', g).addEventListener('click', () => ir(i + 1));
      puntos.forEach((b, k) => b.addEventListener('click', () => ir(k)));
      minis.forEach((b, k) => b.addEventListener('click', () => ir(k)));
      const marco = $('.gp-marco', g);
      let x0 = null, y0 = null;
      marco.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      marco.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(dx < 0 ? i + 1 : i - 1);
      }, { passive: true });
      marco.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') ir(i - 1); if (e.key === 'ArrowRight') ir(i + 1); });
      marco.tabIndex = 0;
      ir(0);
    });
  }

  /* ---------- contadores ---------- */
  function contador(raiz) {
    $$('.cuenta[data-hasta]', raiz).forEach(el => {
      const fin = new Date(el.dataset.hasta).getTime();
      if (isNaN(fin)) return;
      const tic = () => {
        const d = Math.max(0, fin - Date.now());
        const dd = Math.floor(d / 864e5), hh = Math.floor(d % 864e5 / 36e5), mm = Math.floor(d % 36e5 / 6e4), ss = Math.floor(d % 6e4 / 1e3);
        el.innerHTML = [[dd, 'días'], [hh, 'horas'], [mm, 'min'], [ss, 'seg']]
          .map(p => '<div><b>' + String(p[0]).padStart(2, '0') + '</b><span>' + p[1] + '</span></div>').join('');
      };
      tic(); registrarReloj(el, setInterval(tic, 1000));
    });
    const cortos = $$('[data-cuenta-corta]', raiz);
    if (cortos.length) {
      const tic = () => cortos.forEach(el => {
        const fin = new Date(el.dataset.hasta || '').getTime();
        if (isNaN(fin)) { el.textContent = ''; return; }
        const d = Math.max(0, fin - Date.now());
        const dd = Math.floor(d / 864e5), hh = Math.floor(d % 864e5 / 36e5), mm = Math.floor(d % 36e5 / 6e4), ss = Math.floor(d % 6e4 / 1e3);
        el.textContent = (dd ? dd + ' d ' : '') + String(hh).padStart(2, '0') + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
      });
      tic(); registrarReloj(cortos[0], setInterval(tic, 1000));
    }
  }

  /* ---------- popup de bienvenida (formulario real de Shopify) ---------- */
  function popup() {
    const el = $('#popup');
    if (!el) return;
    const visto = () => { try { return localStorage.getItem('botanica_popup') === '1'; } catch (e) { return true; } };
    const marcar = () => { try { localStorage.setItem('botanica_popup', '1'); } catch (e) { /* nada */ } };
    if (el.dataset.exito === '1') { el.classList.add('abierto'); marcar(); return; }
    if (visto()) return;
    setTimeout(() => el.classList.add('abierto'), parseInt(el.dataset.demora || '6000', 10));
    el.addEventListener('click', e => {
      if (e.target === el || e.target.closest('.cerrar,.no')) {
        e.preventDefault(); el.classList.remove('abierto'); marcar();
      }
    });
  }

  /* ---------- antes / después ---------- */
  function antesDespues(raiz) {
    $$('.ad', raiz).forEach(ad => {
      if (ad.dataset.listo === '1') return;
      ad.dataset.listo = '1';
      const r = $('input[type=range]', ad), top = $('.ad-top', ad), linea = $('.ad-linea', ad);
      if (!r || !top || !linea) return;
      const set = v => { top.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)'; linea.style.left = v + '%'; };
      r.addEventListener('input', () => set(r.value));
      set(r.value);
    });
  }

  /* ---------- varios ---------- */
  let reloj;
  function aviso(m) {
    let t = $('#toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = m;
    t.classList.add('ver');
    clearTimeout(reloj);
    reloj = setTimeout(() => t.classList.remove('ver'), 2600);
  }
  function aparecer(raiz) {
    if (!('IntersectionObserver' in window)) { $$('.aparece', raiz).forEach(e => e.classList.add('visto')); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target); } }), { threshold: 0.12 });
    $$('.aparece', raiz).forEach(el => io.observe(el));
  }
  function quitarRotas(raiz) {
    $$('img[data-quitar-si-falla]', raiz).forEach(i => {
      const q = () => { const a = i.closest('article'); if (a) a.remove(); };
      if (i.complete && i.naturalWidth === 0) q(); else i.addEventListener('error', q);
    });
  }
  function menu(raiz) {
    const h = $('.hamb', raiz), m = $('nav.menu', raiz);
    if (!h || !m || h.dataset.listo === '1') return;
    h.dataset.listo = '1';
    h.addEventListener('click', () => m.classList.toggle('abierto'));
    $$('nav.menu a', raiz).forEach(a => a.addEventListener('click', () => m.classList.remove('abierto')));
  }
  function cookies() {
    if (!D.cookies || !D.cookies.mostrar) return;
    try { if (localStorage.getItem('botanica_cookies') === '1') return; } catch (e) { return; }
    const b = document.createElement('div');
    b.className = 'aviso-cookies';
    b.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:70;background:#fff;border-radius:16px;padding:16px 18px;box-shadow:0 20px 50px rgba(0,0,0,.25);display:flex;gap:14px;align-items:center;flex-wrap:wrap;font-size:14px;max-width:720px;margin:0 auto';
    b.innerHTML = '<span style="flex:1;min-width:220px">' + esc(D.cookies.texto || '') +
      (D.cookies.url ? ' <a href="' + esc(D.cookies.url) + '" style="text-decoration:underline">Más información</a>' : '') +
      '</span><button class="btn btn-verde" style="padding:12px 20px;font-size:14px" id="ok-cookies">Aceptar</button>';
    document.body.appendChild(b);
    $('#ok-cookies').addEventListener('click', () => {
      try { localStorage.setItem('botanica_cookies', '1'); } catch (e) { /* nada */ }
      b.remove();
    });
  }

  /* ---------- clics ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-abrir-carrito],[data-cerrar],[data-cupon],[data-mas],[data-menos],[data-quitar],[data-agregar-var]');
    if (!t) return;
    if (t.dataset.abrirCarrito !== undefined) { e.preventDefault(); abrir(); if (!carrito) traer(); }
    else if (t.dataset.cerrar !== undefined) { e.preventDefault(); cerrar(); }
    else if (t.dataset.cupon !== undefined) { e.preventDefault(); aplicarCupon(); }
    else if (t.dataset.mas !== undefined) { const l = carrito.items.find(x => x.key === t.dataset.mas); if (l) cambiar(l.key, l.quantity + 1); }
    else if (t.dataset.menos !== undefined) { const l = carrito.items.find(x => x.key === t.dataset.menos); if (l) cambiar(l.key, l.quantity - 1); }
    else if (t.dataset.quitar !== undefined) { cambiar(t.dataset.quitar, 0); }
    else if (t.dataset.agregarVar !== undefined) { e.preventDefault(); agregar([{ id: parseInt(t.dataset.agregarVar, 10), quantity: parseInt(t.dataset.cantidad || '1', 10) }]); }
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrar(); });

  /* El campo del cupón vive dentro del formulario del carrito y el único botón
     de tipo submit de ese formulario es «Pagar pedido». Sin esta guarda, apretar
     Enter en el cupón mandaba al checkout SIN aplicar el código. */
  document.addEventListener('keydown', e => {
    const campo = e.target && e.target.closest ? e.target.closest('#cupon-in') : null;
    if (!campo) return;
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      aplicarCupon();
    }
  });

  /* formularios de «agregar al carrito»: se interceptan para usar el carrito con cajón */
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-carrito-form]');
    if (!f) return;
    e.preventDefault();
    const d = new FormData(f);
    const id = parseInt(d.get('id'), 10);
    const q = parseInt(d.get('quantity') || '1', 10) || 1;
    if (!id) { f.submit(); return; }
    agregar([{ id: id, quantity: q }]);
  });

  /* interruptores de «sumá con un toque» */
  document.addEventListener('change', e => {
    const t = e.target.closest('[data-toggle-var]');
    if (!t) return;
    const id = parseInt(t.dataset.toggleVar, 10);
    if (t.checked) agregar([{ id: id, quantity: 1 }], { silencioso: true });
    else { const l = enCarrito(id); if (l) cambiar(l.key, 0); }
  });

  /* cantidad en la página de producto */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-q]');
    if (!b) return;
    e.preventDefault();
    const i = document.getElementById(b.dataset.q);
    if (!i) return;
    i.value = Math.max(1, (parseInt(i.value, 10) || 1) + (b.dataset.dir === '+' ? 1 : -1));
  });

  /* ---------- arranque ----------
     En «Personalizar», Shopify reemplaza el HTML de la sección que se está
     editando y dispara shopify:section:load. Si el arranque fuera solo
     DOMContentLoaded, esa sección quedaría sin JavaScript: el carrusel de la
     portada mostraría los tres banners uno al lado del otro, el comparador y los
     packs dejarían de responder y los bloques con .aparece quedarían corridos.
     Por eso iniciar() recibe un trozo del DOM y se puede volver a correr. */
  const relojes = [];
  function registrarReloj(el, id) { relojes.push({ el: el, id: id }); return id; }
  function limpiarRelojes(scope) {
    for (let i = relojes.length - 1; i >= 0; i--) {
      const r = relojes[i];
      const adentro = !scope || scope === document || (r.el && scope.contains && scope.contains(r.el));
      if (adentro) { clearInterval(r.id); relojes.splice(i, 1); }
    }
  }

  function iniciar(scope) {
    const raiz = (scope && scope.querySelectorAll) ? scope : document;
    packs(raiz); galeriaProducto(raiz); contador(raiz); aparecer(raiz);
    antesDespues(raiz); quitarRotas(raiz); menu(raiz);
    if (raiz === document) { popup(); cookies(); }
    (window.BOTANICA_INIT || []).forEach(f => {
      try { f(raiz); } catch (e) { /* una sección con problemas no rompe a las demás */ }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    iniciar(document);
    traer().catch(() => { /* el carrito se vuelve a pedir al abrirlo */ });
  });

  document.addEventListener('shopify:section:load', e => {
    iniciar(e.target);
    if (carrito) pintar(carrito);
  });
  document.addEventListener('shopify:section:unload', e => limpiarRelojes(e.target));
  document.addEventListener('shopify:section:select', e => iniciar(e.target));
  document.addEventListener('shopify:block:select', e => iniciar(e.target));

  window.BOTANICA = {
    agregar: agregar, abrir: abrir, cerrar: cerrar, traer: traer, money: money,
    iniciar: iniciar, registrarReloj: registrarReloj
  };
})();

/* portada: carrusel de banners, pase automático, puntos, flechas y deslizar */
window.BOTANICA_INIT = window.BOTANICA_INIT || [];
window.BOTANICA_INIT.push(function (raiz) {
  (raiz || document).querySelectorAll('.portada').forEach(s => {
    if (s.dataset.listo === '1') return;
    s.dataset.listo = '1';
    const pista = s.querySelector('.pista'), diapos = Array.prototype.slice.call(s.querySelectorAll('.diapo')), puntos = s.querySelector('.puntos');
    if (!pista || diapos.length < 2) return;
    let i = 0, reloj = null;
    const segundos = parseInt(s.dataset.segundos || '4', 10) * 1000;
    diapos.forEach((_, k) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Banner ' + (k + 1));
      b.addEventListener('click', () => ir(k, true));
      if (puntos) puntos.appendChild(b);
    });
    function ir(n, manual) {
      i = (n + diapos.length) % diapos.length;
      pista.style.transform = 'translateX(-' + i * 100 + '%)';
      if (puntos) Array.prototype.slice.call(puntos.children).forEach((b, k) => b.classList.toggle('activo', k === i));
      if (manual) arrancar();
    }
    function arrancar() {
      clearInterval(reloj);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || s.dataset.auto === 'no') return;
      reloj = setInterval(() => ir(i + 1), segundos);
      if (window.BOTANICA && window.BOTANICA.registrarReloj) window.BOTANICA.registrarReloj(s, reloj);
    }
    const prev = s.querySelector('.prev'), next = s.querySelector('.next');
    if (prev) prev.addEventListener('click', () => ir(i - 1, true));
    if (next) next.addEventListener('click', () => ir(i + 1, true));
    let x0 = null;
    s.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    s.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1, true);
    }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(reloj); else arrancar(); });
    ir(0); arrancar();
  });
});

/* hero con pase de imágenes (zoom lento y fundido) */
window.BOTANICA_INIT.push(function (raiz) {
  const hero = (raiz || document).querySelector('.hero .slides');
  if (!hero || hero.dataset.listo === '1') return;
  hero.dataset.listo = '1';
  const slides = Array.prototype.slice.call(hero.querySelectorAll('.slide'));
  if (slides.length < 2) return;
  const puntos = document.querySelector('.hero .puntos');
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let i = 0, reloj = null;
  slides.forEach((s, k) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Imagen ' + (k + 1));
    b.addEventListener('click', () => ir(k, true));
    if (puntos) puntos.appendChild(b);
  });
  function ir(n, manual) {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('activa', k === i));
    if (puntos) Array.prototype.slice.call(puntos.children).forEach((b, k) => b.classList.toggle('activo', k === i));
    if (manual) arrancar();
  }
  function arrancar() {
    clearInterval(reloj);
    if (quieto) return;
    reloj = setInterval(() => ir(i + 1), 5500);
    if (window.BOTANICA && window.BOTANICA.registrarReloj) window.BOTANICA.registrarReloj(hero, reloj);
  }
  const prev = document.querySelector('.hero .ctrl.prev'), next = document.querySelector('.hero .ctrl.next');
  if (prev) prev.addEventListener('click', () => ir(i - 1, true));
  if (next) next.addEventListener('click', () => ir(i + 1, true));
  document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(reloj); else arrancar(); });
  ir(0); arrancar();
});

/* opiniones: la cinta avanza sola; al tocarla en el celular se pausa y se puede deslizar */
window.BOTANICA_INIT.push(function (raiz) {
  (raiz || document).querySelectorAll('.resenas-carrusel').forEach(c => {
    if (c.dataset.listo === '1') return;
    c.dataset.listo = '1';
    let x0 = null;
    c.addEventListener('touchstart', e => { c.classList.add('pausa'); x0 = e.touches[0].clientX; }, { passive: true });
    c.addEventListener('touchmove', e => {
      if (x0 === null) return;
      const cinta = c.querySelector('.cinta');
      if (cinta) cinta.style.marginLeft = (e.touches[0].clientX - x0) + 'px';
    }, { passive: true });
    c.addEventListener('touchend', () => {
      x0 = null;
      setTimeout(() => {
        c.classList.remove('pausa');
        const cinta = c.querySelector('.cinta');
        if (cinta) cinta.style.marginLeft = '';
      }, 2500);
    });
  });
});
